'use strict';
const template = require('./entity-placeholder-directive.html');

module.exports = [
  EntityPlaceholderDirective];

function EntityPlaceholderDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      config: '=',
    },
  };
}



// WEBPACK FOOTER //
// ./src/js/core-components/entity-placeholder/EntityPlaceholderDirective.js